/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Draft_DiscardInputs */

const en_us2_coaching_draft_discard = /** @type {(inputs: Coaching_Draft_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard`)
};

const pt_br2_coaching_draft_discard = /** @type {(inputs: Coaching_Draft_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

const pt_pt2_coaching_draft_discard = /** @type {(inputs: Coaching_Draft_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

/** @type {(inputs: Coaching_Draft_DiscardInputs) => LocalizedString} */
const es_419_coaching_draft_discard = en_us2_coaching_draft_discard;

/** @type {(inputs: Coaching_Draft_DiscardInputs) => LocalizedString} */
const fr_fr2_coaching_draft_discard = en_us2_coaching_draft_discard;

/** @type {(inputs: Coaching_Draft_DiscardInputs) => LocalizedString} */
const de_de2_coaching_draft_discard = en_us2_coaching_draft_discard;

/** @type {(inputs: Coaching_Draft_DiscardInputs) => LocalizedString} */
const it_it2_coaching_draft_discard = en_us2_coaching_draft_discard;

/**
* | output |
* | --- |
* | "Discard" |
*
* @param {Coaching_Draft_DiscardInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_draft_discard = /** @type {((inputs?: Coaching_Draft_DiscardInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Draft_DiscardInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_draft_discard(inputs)
	if (locale === "es-419") return es_419_coaching_draft_discard(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_draft_discard(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_draft_discard(inputs)
	if (locale === "de-DE") return de_de2_coaching_draft_discard(inputs)
	if (locale === "it-IT") return it_it2_coaching_draft_discard(inputs)
	return en_us2_coaching_draft_discard(inputs)
});
export { coaching_draft_discard as "coaching.draft_discard" }